const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellnessHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.49 33.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75,11.14c1-1,3.43-2.66,5.72-2.66,4.15,0,8.27,3.49,8.27,10.14,0,7.28-5.26,13.94-10.49,13.94-1.33,0-2.34-1-3.5-1s-2.18,1-3.5,1C6,32.56.75,25.9.75,18.62.75,12,4.88,8.48,9,8.48,11.32,8.48,13.7,10.13,14.75,11.14Z",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6,18.62H4.54c0-4.38,2.32-6.37,4.48-6.37v.06C6.89,12.31,4.6,14.29,4.6,18.62Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78,9.75h-.06A7.61,7.61,0,0,0,7.11,2.17V2.11A7.66,7.66,0,0,1,14.78,9.75Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.62,6a4.32,4.32,0,0,0,2.12-4.34,4.35,4.35,0,0,0-4.83-.33,4.3,4.3,0,0,0-2.12,4.33A4.35,4.35,0,0,0,19.62,6Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessHealth);
export default __webpack_public_path__ + "static/media/wellness_health.77c44230575bc1f7a2da855d2010693f.svg";
export { ForwardRef as ReactComponent };